export default {
    salesLastSaleSource: 'agentAdvised',
    isActiveForSaleCampaign: 'isActiveListingsOnly',
    isActiveForRentCampaign: 'isActiveListingsOnly',
};
